import { Button } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useTopPanel from 'hooks/useTopPanel';
import BaseTable from 'components/ui/tables/BaseTable';
import AddEditModal from './AddEditModal';
import SimpleSearchInput from 'components/SearchInputNavbar';

const Partners = () => {
  const navigate = useNavigate();
  const { setComponent } = useTopPanel();

  const [refetch, setRefetch] = useState(false);
  const [openStaffModal, setOpenStaffModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [ItemData, setItemData] = useState({});

  const onHistory = (data) => {
    navigate(`${data?.id}/history?customerName=${data?.name}`);
  };

  useEffect(() => {
    setComponent(<div className='component-title'>Hamkorlar</div>);
  }, []);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='success'
              className='!mx-2'
              onClick={() => setOpenStaffModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/partners/index'
          emitTableColumns={{ open, setOpen }}
          tableName='Partners'
          headCells={[
            { code: 'name', label: 'Nomi' },
            { code: 'sum', label: 'Summa' },
            { code: 'valute', label: 'Valyuta' },
          ]}
          columns={[
            { code: 'name' },
            { code: 'sum', type: 'priceSum' },
            { code: 'valute', type: 'price' },
          ]}
          actionsList={[
            {
              icon: 'bi bi-eye',
              btnColor: 'warning',
              setOpen: () => {},
              setData: onHistory,
            },
            {
              icon: 'bi bi-pencil-square',
              btnColor: 'info',
              setOpen: setOpenStaffModal,
              setData: setItemData,
            },
          ]}
        />
      </div>
      {openStaffModal && (
        <AddEditModal
          open={openStaffModal}
          setOpen={setOpenStaffModal}
          itemData={ItemData}
          setItemData={setItemData}
          setRefetch={setRefetch}
        />
      )}
    </div>
  );
};

export default memo(Partners);
